<template>
    <div class="news-list uk-grid uk-grid-large" uk-grid  uk-scrollspy="target: > *; cls: uk-animation-fade uk-animation-slide-bottom-small; delay: 250">
        <div v-for="item in items" class="uk-width-1-2@s uk-width-1-3@m">
          <div class="product-card product-card--vertical@s" :class="item.main_type.data.slug" data-uk-rr-grid-item>
            <a :href="item.url" class="product-card__link">
              <div class="product-card__media-wrapper" v-if="item.thumbnail_media">
                <div class="product-card__media" v-html="item.thumbnail_media.data.thumbnail"></div>
                <div class="product-card__label">{{item.main_category.data.name}}</div>
                <div class="lazyload product-card__logo" v-if="item.logo_white_media" v-html="item.logo_white_media.data.thumbnail"></div>
              </div>
              <div class="product-card__body">
                <div class="product-card__title"><div class="product-card__label">{{item.main_category.name}}</div> {{item.name}}</div>
                <p class="product-card__text">{{item.abstract}}</p>
              </div>
            </a>
          </div>
        </div>
    </div>

</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/imbotex/extensions/rubinred/collections/assets/js/ProductsDataGridResults.vue